import React from "react";
import { Field } from "react-final-form";
import { teacherRegisterDetailsConfig } from "../../../constants";
import { AccordionEditor } from "./AccordionEditor";
import { makeStyles, Typography } from "@material-ui/core";
import { DetailType } from "../../../types";

const useStyles = makeStyles(() => ({
  root: {
    marginBottom: 16,
  },
  title: {
    marginTop: 8,
    marginBottom: 16,
    fontSize: 18,
    fontWeight: "bold",
    color: "#535358",
  },
}));

export function Accordions({ name }: { name: string }) {
  const [expanded, setExpanded] = React.useState<DetailType>();
  const classes = useStyles();

  const handleExpand = (panel) => (_, newExpanded) => {
    setExpanded(newExpanded ? panel.type : false);
  };

  return (
    <div className={classes.root}>
      {teacherRegisterDetailsConfig.map((item) => (
        <Field
          key={item.type}
          isExpanded={expanded === item.type}
          isRequired={item.isRequired}
          onExpand={() => handleExpand(item)}
          title={item.name}
          type="text"
          name={`${name}.details.type_${item.type}`}
          component={AccordionEditor}
        />
      ))}
    </div>
  );
}
